<div class="row">
    <p class="dialog-title">
        <strong>Payment confirmation |</strong> Validate payment
    </p>
</div>
<np-pin-twillio-authy [buttonName]="btnName" [email]="registerService.email" [pinCodeError]="pinCodeError"
    (onetouchApproved)="confirmPassCode()" (submitted)="confirmPassCode($event)" (sendCode)="sendCode($event)"
    [ticketType]="ticketType" [authyScreenType]="3" [sendOnetouchSuccess]="sendOnetouchSuccess"></np-pin-twillio-authy>